import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class ProductFacetValueDto
*  Значение дискретного фасета
*/
export class ProductFacetValueDto extends ActiveModel {

/**
  * val
  * Значение для `Filter.Attrs[].val`
  */
  @ActiveField('')
  val: string = ''


/**
  * label
  * Подпись для сайдбара<br>
  */
  @ActiveField('')
  label: string = ''


  /**
  * count
  * Число карточек в срезе без этого фасета<br>  */
  @ActiveField(0)
  count: number = 0


  /**
  * selected
  * Значение выбрано в текущем `Filter.Attrs`  */
  @ActiveField(false)
  selected: boolean = false
}
